const LAST_SPLIT_VIEW_LEFT_WIDTH = 'lastSplitViewLeftWidth'

export const lastSplitViewLeftWidthStore = {
  get(): number | null {
    const qqq = localStorage.getItem(LAST_SPLIT_VIEW_LEFT_WIDTH)
    if (!qqq) return null
    return parseInt(qqq, 10)
  },
  set(lastSplitViewLeftWidth: number): void {
    localStorage.setItem(LAST_SPLIT_VIEW_LEFT_WIDTH, `${lastSplitViewLeftWidth}`)
  },
  clear(): void {
    localStorage.removeItem(LAST_SPLIT_VIEW_LEFT_WIDTH)
  },
}
